import { render } from "./InputRadio.vue?vue&type=template&id=40153d02"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__